import React, { useEffect } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import error from './error.svg';
import './NotFound.css';

const { Title } = Typography;

function NotFound() {
    const { t } = useTranslation();

    useEffect(() => {
        document.title = `${t('notFound')}`;
    }, []);

    return (
        <>
            <div id="content">
                <Title level={1} className="notFoundPageTitle">{t('notFound')}</Title>
                <img src={error} alt="404 error" className='image' />
            </div>
        </>
    )
}

export default NotFound;